function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { connect } from 'react-redux';
import { Helmet as ReactHelmet } from 'react-helmet';
import { helmetSelector } from '../../../../redux/meta/meta.selectors';
import { createControls } from '../../../routes/client/product-listing/components/hidden-pagination/hidden-pagination';
import { DEFAULT_DESCRIPTION } from './contants';
export function HelmetWrapper({
  title,
  description,
  robots,
  image,
  type,
  canonical,
  currentPage,
  isAllProductsListPage,
  isProductsListFetched,
  location,
  currentPageNumber,
  currentPerPage,
  pageCount,
  isNoIndex = false,
  schemaOrgProduct
}) {
  const link = canonical || currentPage;
  const controls = createControls({
    location,
    currentPage: currentPageNumber,
    currentPerPage,
    pageCount,
    isHead: true
  });
  return /*#__PURE__*/React.createElement(ReactHelmet, null, title && /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: description || DEFAULT_DESCRIPTION
  }), robots && /*#__PURE__*/React.createElement("meta", {
    name: "robots",
    content: robots
  }), title && /*#__PURE__*/React.createElement("meta", {
    property: "og:title",
    content: title
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:description",
    content: description || DEFAULT_DESCRIPTION
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:type",
    content: type || 'product'
  }), /*#__PURE__*/React.createElement("meta", {
    property: "og:url",
    content: window.location.href
  }), image && /*#__PURE__*/React.createElement("meta", {
    property: "og:image",
    content: image
  }), /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: link || window.location.href
  }), isAllProductsListPage && isProductsListFetched && controls, isNoIndex && /*#__PURE__*/React.createElement("meta", {
    name: "robots",
    content: "noindex, noarchive"
  }), schemaOrgProduct && /*#__PURE__*/React.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(_objectSpread({
    '@context': 'https://schema.org',
    '@type': 'Product',
    name: schemaOrgProduct.name,
    image: schemaOrgProduct.image,
    description: schemaOrgProduct.description,
    brand: {
      '@type': 'Brand',
      name: 'Swag'
    },
    sku: schemaOrgProduct.sku
  }, schemaOrgProduct.color ? {
    color: schemaOrgProduct.color
  } : {}, {
    offers: _objectSpread({
      '@type': 'Offer',
      priceCurrency: 'USD'
    }, schemaOrgProduct.url ? {
      url: schemaOrgProduct.url
    } : {}, {
      price: schemaOrgProduct.price,
      availability: schemaOrgProduct.inStock ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
      seller: {
        '@type': 'Organization',
        name: 'Swag'
      }
    })
  }))));
}
export const Helmet = connect(helmetSelector)(HelmetWrapper);